module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[1] for opt in $ctrl.delivery\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n   <option value=\"\">Choose delivery ...</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/delivery.picker.html
// module id = 610
// module chunks = 0